export enum Role {
    Guest = 'Guest',
    Administrator = 'Administrator',
    Editor = 'Editor',
    Wellness = 'Wellness'
  }
